export const USER_SEARCH_TRIPS = "USER_SEARCH_TRIPS";